import { createAction } from "@reduxjs/toolkit";

// export const setPreviousPath = createAction("previousPath/setPreviousPath");
export const setPreviousPath = createAction<string, "setPreviousPath">(
  "setPreviousPath"
);
